import React, { useState, useEffect } from "react";
import _ from "lodash";

import styles from "./index.module.scss";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "../../components/TextField";
import Autocomplete from "../../components/Autocomplete";
import Button from "../../components/Button";
import { useNotification } from "../../context/notification";
import DeleteIcon from "@material-ui/icons/Delete";
import { useTranslation } from "react-i18next";

export default function AddCoach({
  coachList,
  filterOptions,
  allCoaches,
  onUpdateCoachList,
  label,
  child = false,
  campaignId,
  defaultCampaignID = false,
}) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const [selectedCoaches, setSelectedCoaches] = useState(null);
  const [assignedCoaches, setAssignedCoaches] = useState(coachList);
  const [addCoachCheck, setAddCoachCheck] = useState(false);

  useEffect(() => {
    onUpdateCoachList(assignedCoaches);
    return () => {};
  }, [assignedCoaches]);

  useEffect(() => {
    setAssignedCoaches(coachList);
    return () => {};
  }, [coachList]);

  const addCoaches = () => {
    if (selectedCoaches) {
      if (
        _.find(assignedCoaches, { employee_id: selectedCoaches.employee_id })
      ) {
        addNotification(t("error.selectedCoachIsAlreadyInTheList"), "error");
      } else {
        setAssignedCoaches([
          ...assignedCoaches,
          {
            ...selectedCoaches,
            campaign_id: campaignId
              ? campaignId
              : parseInt(selectedCoaches.campaign_id),
          },
        ]);
      }
    }
  };

  const deleteAssignedCoaches = item => {
    const remainingItems = [
      ...assignedCoaches.filter(list => list.employee_id !== item.employee_id),
    ];
    setAssignedCoaches(remainingItems);
  };

  return (
    <>
      {!child && (
        <>
          <div className={styles.profileRow}>
            <div className={styles.rowLeft} style={{ paddingTop: "16px" }}>
              {label ? label : ""}
            </div>
            <div
              className={styles.rowRight}
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <Autocomplete
                id="coach"
                value={selectedCoaches}
                onChange={(event, newValue) => {
                  setSelectedCoaches(newValue);
                }}
                filterOptions={filterOptions}
                options={allCoaches}
                getOptionLabel={option => option.u_fullname}
                style={{ width: 280 }}
                renderInput={params => (
                  <TextField
                    {...params}
                    placeholder="Type a name or Employee ID"
                    variant="outlined"
                  />
                )}
              />
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                style={{ marginLeft: "6px" }}
                onClick={addCoaches}
              >
                {t("userManagement.add")}
              </Button>
            </div>
          </div>
          {assignedCoaches.length > 0 && (
            <div className={styles.profileRow}>
              <div
                className={styles.rowLeft}
                style={{ paddingTop: "16px" }}
              ></div>
              <div className={styles.rowRight}>
                <table className={styles.coachTable}>
                  <thead>
                    <tr>
                      <th width="50%">{t("userManagement.name")}</th>
                      <th width="25%">{t("userManagement.id")}</th>
                      <th width="20%">{t("userManagement.role")}</th>
                      <th width="50%">{t("userManagement.status")}</th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    {assignedCoaches &&
                      !defaultCampaignID &&
                      assignedCoaches.map((item, index) => (
                        <tr key={index}>
                          <td>{item.u_fullname}</td>
                          <td>{item.employee_id}</td>
                          <td>{item.u_role_value}</td>
                          <td
                            className={
                              item.status === "Active"
                                ? styles.statusActive
                                : styles.statusInactive
                            }
                          >
                            {item.status}
                          </td>
                          <td>
                            <DeleteIcon
                              onClick={() => {
                                deleteAssignedCoaches(item);
                              }}
                              style={{
                                color: "#9E9E9E",
                                fontSize: 16,
                                cursor: "pointer",
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    {assignedCoaches &&
                      defaultCampaignID &&
                      assignedCoaches
                        .filter(item => {
                          return item.campaign_id === defaultCampaignID;
                        })
                        .map((item, index) => (
                          <tr key={index}>
                            <td>{item.u_fullname}</td>
                            <td>{item.employee_id}</td>
                            <td>{item.u_role_value}</td>
                            <td
                              className={
                                item.status === "Active"
                                  ? styles.statusActive
                                  : styles.statusInactive
                              }
                            >
                              {item.status}
                            </td>
                            <td>
                              <DeleteIcon
                                onClick={() => {
                                  deleteAssignedCoaches(item);
                                }}
                                style={{
                                  color: "#9E9E9E",
                                  fontSize: 16,
                                  cursor: "pointer",
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}

      {child && (
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={addCoachCheck}
                onChange={event => {
                  setAddCoachCheck(event.target.checked);
                }}
                name="checkedB"
                color="secondary"
              />
            }
            label={t("userManagement.AddCoach")}
          />

          {addCoachCheck && (
            <>
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                <Autocomplete
                  id="coach"
                  value={selectedCoaches}
                  onChange={(event, newValue) => {
                    setSelectedCoaches(newValue);
                  }}
                  filterOptions={filterOptions}
                  options={allCoaches}
                  getOptionLabel={option => option.u_fullname}
                  style={{ width: 280 }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      placeholder="Type a name or Employee ID"
                      variant="outlined"
                    />
                  )}
                />
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  style={{ marginLeft: "6px" }}
                  onClick={addCoaches}
                >
                  {t("userManagement.add")}
                </Button>
              </div>
              <div style={{ marginTop: "20px" }}>
                {assignedCoaches.length > 0 && (
                  <table className={styles.coachTable}>
                    <thead>
                      <tr>
                        <th width="50%">{t("userManagement.name")}</th>
                        <th width="25%">{t("userManagement.id")}</th>
                        <th width="20%">{t("userManagement.role")}</th>
                        <th width="50%">{t("userManagement.status")}</th>
                        <th width="5%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignedCoaches &&
                        assignedCoaches
                          .filter(item => {
                            if (typeof item.campaign_id === "string") {
                              const campaignIds = item.campaign_id.split(",");
                              let currentCampaignId = [];

                              campaignIds.forEach(cid => {
                                if (parseInt(cid) === campaignId) {
                                  currentCampaignId.push(true);
                                }
                              });

                              if (currentCampaignId.length > 0) {
                                return item;
                              }
                            } else {
                              return item.campaign_id == campaignId;
                            }
                          })
                          .map((item, index) => (
                            <tr key={index}>
                              <td>{item.u_fullname}</td>
                              <td>{item.employee_id}</td>
                              <td>{item.u_role_value}</td>
                              <td
                                className={
                                  item.status === "Active"
                                    ? styles.statusActive
                                    : styles.statusInactive
                                }
                              >
                                {item.status}
                              </td>
                              <td>
                                <DeleteIcon
                                  onClick={() => {
                                    deleteAssignedCoaches(item);
                                  }}
                                  style={{
                                    color: "#9E9E9E",
                                    fontSize: 16,
                                    cursor: "pointer",
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                )}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}